// LoginForm.jsx
import React, { useState } from "react";
import axios from "axios";
import logo from "../assets/bayautomation.png";


export default function LoginForm({ setToken }) {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState(null);
  const API_BASE ="https://bayautomation-qctracker.co.za";


  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      const res = await axios.post(`${API_BASE}/auth/login`, { username, password });
      localStorage.setItem("token", res.data.token);
      setToken(res.data.token);
    } catch (err) {
      setError("Invalid username or password");
    }
  };

  return (
    <form onSubmit={handleLogin} className="max-w-sm mx-auto mt-20 space-y-4 p-4 bg-white shadow-md rounded">
      {/* 🔻 Bay Automation logo at the top */}
      <img
        src={logo}
        alt="Bay Automation"
        className="w-40 mx-auto mb-4"
      />

      <h2 className="text-xl font-bold">Login</h2>
      {error && <div className="text-red-600 text-sm">{error}</div>}
      <input type="text" placeholder="Username" value={username} onChange={(e) => setUsername(e.target.value)} className="w-full border p-2 rounded" required />
      <input type="password" placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} className="w-full border p-2 rounded" required />
      <button type="submit" className="w-full bg-blue-600 text-white py-2 rounded hover:bg-blue-700">Login</button>
    </form>
  );
}
